import React from 'react';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios"

import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";

import Header from "layouts/headers/NormalHeader"
import HeaderTag from "layouts/yetkilendirme/Header"

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PermissionNavbar from "examples/Navbars/PermissionNavbar";

import curved0 from "assets/images/curved-images/curved-trt-duz.png";

// Soft UI Dashboard React components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TransparentInfoCard from "examples/Cards/InfoCards/TransparentInfoCard";

const Yetkilendirme = () => {


    const [data, setData] = useState([]);
    const [dataOpt, setDataOpt] = useState([]);

    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedRoleText, setSelectedRoleText] = useState("-");

    const handleSelectChange = (option) => {
        setSelectedRole(option.value);
        setSelectedRoleText(option.label);
    };

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                if (selectedRole) {
                    const response = await axios.get(`${window.BASE_URL}/permissions/${selectedRole}?format=json`, { withCredentials: true });
                    setData(response.data);
                }
                else {
                    const response = await axios.get(`${window.BASE_URL}/groups?format=json`, { withCredentials: true });
                    setDataOpt(response.data);
                }
            } catch (error) {
                console.log(error);

            }
            finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [selectedRole]);

    const formattedOptions = dataOpt.map(role => ({
        label: role.name,
        value: role.id
    }));

    let items_acc = [];
    let items_create = [];
    let items_delete = [];

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [selectedCards, setSelectedCards] = useState({});

    const handleKeyClicked = (key, value) => {

        if (value !== 2) {
            setSelectedCards(prevState => {
                const currentValue = prevState[key] !== undefined ? prevState[key] : value; // Mevcut değeri al
                const newValue = currentValue === 0 ? 1 : 0; // 0 → 1, 1 → 0

                // Eğer yeni değer başlangıçtaki `value` ile eşitse key'i sil
                if (newValue === value) {
                    const updatedState = { ...prevState };
                    delete updatedState[key];
                    return updatedState;
                }

                return {
                    ...prevState,
                    [key]: newValue
                };
            });
        }
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
          const payload = {
            group: selectedRole, // veya istediğiniz kategoriyi burada kullanabilirsiniz
            selectedCards,
          };
      
          await axios.post(`${window.BASE_URL}/permissions-edit`, payload, {
            withCredentials: true,
          });


            window.location.reload();
      
          // İşlem başarılıysa geribildirim veya ek bir işlem ekleyebilirsiniz
        } catch (error) {
          console.error("Kayıt hatası:", error);
        } finally {
          setIsSubmitting(false);
        }
      };


    // JSON nesnesindeki her bir key-value çifti için döngü
    Object.entries(data)
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // Anahtarları alfabetik sıraya göre sıralar
        .forEach(([key, value]) => {

            const currentValue = selectedCards[key] ?? value;
            const cardColor = currentValue === 0 ? "light" : currentValue === 1 ? "info" : "dark";

            const card = (
                <Grid item xs={6} md={2} key={key} onClick={() => handleKeyClicked(key, value)} >
                    <TransparentInfoCard
                        color={cardColor}
                        icon="vpn_key"
                        description={key}
                        value={
                            <>
                                <SoftTypography component="span" variant="button" isLoading={isLoading} skeletonWidth="70px">
                                    {selectedCards[key] !== undefined && selectedCards[key] !== value ? "DÜZENLEME" : value === 0 ? "‎" : value === 1 ? "Açık" : "Sabit"}
                                </SoftTypography>
                            </>
                        }
                    />
                </Grid>
            );

            // Anahtar değerini kontrol ederek doğru listeye ekle
            if (key.startsWith("Acc")) {
                items_acc.push(card);
            } else if (key.startsWith("Create")) {
                items_create.push(card);
            } else if (key.startsWith("Delete")) {
                items_delete.push(card);
            }
        });

    const [selectedTab, setSelectedTab] = useState(0);

    const handleCategoryChange = (category) => {
        setSelectedTab(category);
    }

    return (
        <DashboardLayout>

            <HeaderTag data={selectedRoleText} onChange={handleCategoryChange} />

            <SoftBox
                style={{
                    position: "absolute",
                    zIndex: 1,
                    right: "7%",
                    top: "320px",
                }}
                sx={{
                    display: { xs: "grid", sm: "flex" }, // Responsive display
                }}
            >


                <SoftBox>
                    <SoftSelect
                        placeholder="Tüm Birimler"
                        onChange={handleSelectChange} // Seçimi state'e aktar
                        options={formattedOptions}
                    />
                </SoftBox>
            </SoftBox>



            {selectedTab == 0 || selectedTab == 1 ? <>  <div>
                <SoftTypography variant="h6" fontWeight="medium" ml={2} mt={6}>
                    Sayfa Görüntüleme Yetkileri
                </SoftTypography>
                <SoftBox mb={2} ml={2}>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                        Yetkileri Görüntüleme ve Düzenleme
                        <SoftTypography variant="button" color="text" fontWeight="medium">
                            {" " + items_acc.length} Yetki
                        </SoftTypography>
                    </SoftTypography>
                </SoftBox>
            </div>
                <Grid container spacing={3} >
                    {items_acc}
                </Grid> </> : ""}


            {selectedTab == 0 || selectedTab == 2 ? <>   <div>
                <SoftTypography variant="h6" fontWeight="medium" ml={2} mt={6}>
                    Kayıt Oluşturma Yetkileri
                </SoftTypography>
                <SoftBox mb={2} ml={2}>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                        Kayıt Oluşturma
                        <SoftTypography variant="button" color="text" fontWeight="medium">
                            {" " + items_create.length} Yetki
                        </SoftTypography>
                    </SoftTypography>
                </SoftBox>
            </div>
                <Grid container spacing={3} >
                    {items_create}
                </Grid>
            </> : ""}


            {selectedTab == 0 || selectedTab == 3 ? <>  <div>
                <SoftTypography variant="h6" fontWeight="medium" ml={2} mt={6}>
                    Kayıt Silme Yetkileri
                </SoftTypography>
                <SoftBox mb={2} ml={2}>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                        Kayıtları Silme
                        <SoftTypography variant="button" color="text" fontWeight="medium">
                            {" " + items_delete.length} Yetki
                        </SoftTypography>
                    </SoftTypography>
                </SoftBox>
            </div>
                <Grid container spacing={3} >
                    {items_delete}
                </Grid>
            </> : ""}
            <Grid container spacing={3} mt={selectedRole ? 0 : 1} style={{justifyContent:"center"}} >
                <Grid item xs={12} lg={11.6} >
                    <Card id="kaydet" style={{ background: "linear-gradient(45deg, #f8f8f8, #ffffff17)" }}>
                        <SoftBox p={3} lineHeight={1}>
                            <SoftBox mb={1}>
                                <SoftTypography variant="h5">{"Kayıt Düzenle"}</SoftTypography>
                            </SoftBox>
                            <SoftTypography variant="button" color="text" fontWeight="regular">
                                {
                                    "Bu sekmede yaptığınız değişiklikleri ve düzenlemeleri kaydedebilirsiniz."}
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox pb={3} px={3} display="flex" justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} flexDirection={{ xs: "column", sm: "row" }}>
                            <SoftBox display="flex" alignItems="center" mb={{ xs: 3, sm: 0 }}>

                            </SoftBox>
                            <SoftBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>

                                <SoftBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                                    <SoftButton
                                        variant="gradient"
                                        color={"info"}
                                        onClick={handleSubmit}
                                        disabled={Object.keys(selectedCards).length > 0 && !isSubmitting ? false : true}
                                        
                                    >
                                        {"Kaydet"}

                                    </SoftButton>

                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                    </Card>
                </Grid>
            </Grid>
        </DashboardLayout>

    );
};

export default Yetkilendirme;